(() => {
  // 1) Esto define "qué buscamos": el bloque de comprar
  const SEL = 'product-form, form[action*="/cart/add"]';

  // 2) Aquí guardamos la copia del HTML del botón/form
  let savedHTML = null;

  // 3) Un "marcador" invisible para saber dónde reinsertarlo
  let marker = null;

  // 4) Para evitar que se reinserte en bucle infinito
  let restores = 0;

  // Guarda una copia del form si lo encuentra
  function backup() {
    if (savedHTML) return true;

    const el = document.querySelector(SEL);
    if (!el) return false;

    savedHTML = el.outerHTML;

    // ponemos un comentario invisible justo después del form
    marker = document.createComment('atc-marker');
    el.parentNode.insertBefore(marker, el.nextSibling);

    console.log('[fixes] Copia del ATC guardada ✅');
    return true;
  }

  // Si falta el form, lo restaura
  function restoreIfMissing() {
    if (!savedHTML || !marker) return;

    // si ya existe, no hacemos nada
    if (document.querySelector(SEL)) return;

    // freno por si algo lo borra constantemente
    if (restores >= 3) return;

    const tmp = document.createElement('div');
    tmp.innerHTML = savedHTML;

    const node = tmp.firstElementChild;
    marker.parentNode.insertBefore(node, marker);

    restores++;
    console.warn('[fixes] ATC restaurado ✅', { restores });
  }

  // Arranca: guarda copia + vigila cambios en la página
  function boot() {
    backup();
    restoreIfMissing();

    const mo = new MutationObserver(() => {
      backup();
      restoreIfMissing();
    });

    mo.observe(document.documentElement, { subtree: true, childList: true });
  }

  // Ejecuta cuando el DOM está listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
document.addEventListener('DOMContentLoaded', function () {
  function forceVariantImageOnClick() {
    const variantPickers = document.querySelectorAll('variant-selects, variant-radios');

    variantPickers.forEach(function (picker) {
      let variants = [];

      const json = picker.querySelector('script[type="application/json"]');
      if (json) {
        try {
          variants = JSON.parse(json.textContent);
        } catch (e) {
          variants = [];
        }
      }

      if (!variants.length) return;

      function getSelectedOptions() {
        const options = [];

        picker.querySelectorAll('fieldset').forEach(function (fieldset) {
          const checked = fieldset.querySelector('input[type="radio"]:checked');
          if (checked) options.push(checked.value);
        });

        picker.querySelectorAll('select').forEach(function (select) {
          options.push(select.value);
        });

        return options;
      }

      function findSelectedVariant() {
        const selectedOptions = getSelectedOptions();

        return variants.find(function (variant) {
          return variant.options.every(function (option, index) {
            return option === selectedOptions[index];
          });
        });
      }

      function showVariantMedia() {
        const selectedVariant = findSelectedVariant();

        if (!selectedVariant || !selectedVariant.featured_media) return;

        const gallery = document.querySelector('media-gallery');
        if (!gallery || typeof gallery.setActiveMedia !== 'function') return;

        const sectionId = picker.dataset.section;
        const mediaId = selectedVariant.featured_media.id;

        if (sectionId) {
          gallery.setActiveMedia(sectionId + '-' + mediaId, true);
        }
      }

      picker.addEventListener('click', function (event) {
        if (
          event.target.matches('input[type="radio"]') ||
          event.target.matches('label') ||
          event.target.closest('label') ||
          event.target.matches('select')
        ) {
          setTimeout(showVariantMedia, 80);
        }
      });
    });
  }

  forceVariantImageOnClick();
});